import { batch, signal } from '@preact/signals-react';
import { Profile } from '../../../common/models/Profile';
import { Project } from '../../../projects/common/models/Project';

export enum ExportFormat {
  PRINT = 'print',
  CSV = 'csv',
}

export class ProjectExportState {
  private static instance: ProjectExportState | null = null;

  readonly profile = signal<Profile | null>(null);
  readonly project = signal<Project | null>(null);

  readonly withExceptions = signal(false);

  readonly format = signal(ExportFormat.PRINT);

  static getInstance() {
    if (!ProjectExportState.instance) {
      ProjectExportState.instance = new ProjectExportState();
    }
    return ProjectExportState.instance;
  }

  setState(project: Project) {
    batch(() => {
      const defaultProfile = project.getDefaultProfile();
      this.project.value = project;
      this.profile.value = defaultProfile ?? null;
      this.withExceptions.value = false;
    });
  }

  reset() {
    batch(() => {
      this.project.value = null;
      this.profile.value = null;
      this.withExceptions.value = false;
    });
  }

  peek() {
    return {
      project: this.project.peek(),
      withExceptions: this.withExceptions.peek(),
      format: this.format.peek(),
    };
  }

  setWithExceptions(value: boolean) {
    this.withExceptions.value = value;
  }

  setFormat(format: ExportFormat) {
    this.format.value = format;
  }
}
